<template>
  <div class="p-4">    
    <l-l-selection class="mb-4" :networks="networks" @click="onShowScalingpoints" />

    <l-l-chart-simple :series="sp_series" v-show="showGrid" ref="chart-simple" />
    <l-info-box class="mb-4" :active="showGrid">Right click the grid to add, edit or delete scaling points</l-info-box>
    
    <hot-table :data="scalingpoints" :settings="settings" v-show="showGrid" ref="hot">
      <hot-column title="Timestamp" data="timestamp" read-only="true"></hot-column>      
      <hot-column title="Zero point" data="zero_point" read-only="true" type="numeric"></hot-column>        
      <hot-column title="Span value" data="span_value" read-only="true" type="numeric"></hot-column>
      <hot-column title="Gas concentration" data="gas_concentration" read-only="true" type="numeric"></hot-column>             
      <hot-column title="Created by" data="createdby" read-only="true"></hot-column>                   
    </hot-table>

    <l-l-edit :showing="edit" @save="onSaveScalingPoint" @close="onClose" :scalingpoint="selectedScalingPoint" :oc_id="selectedOCId" />
    <l-l-add :showing="add" @save="onSaveScalingPoint" @close="onClose" :oc_id="selectedOCId" />
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import LLSelection from "./LLSelection";
import LLEdit from "./LLEdit";
import LLAdd from "./LLAdd";
import ScalingService from "@/helpers/services/processing/scaling.service";
import Notify from "@/helpers/notify";
import LLChartSimple from "./LLChartSimple"

import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import * as moment from "moment";

import LInfoBox from "@/components/LInfoBox";
export default {
  name: "Scaling",
  components: {
    LLSelection,
    HotTable,
    HotColumn,
    LInfoBox,
    LLEdit,
    LLAdd,
    LLChartSimple
  },
  data() {
    return {
      edit:false,
      add:false,
      selectedOCId: "",
      selectedScalingPoint:{},
      showGrid:false,
      dataset: [],
      networks: [],
      scalingpoints:[],
      settings: HandsontableHelper.settings(false)
    };
  },
  mounted() {
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    Notify.loadData(null, this.loadInitialData);
  },
  computed: {
    sp_series() {
      const span = { name: 'Span', type: 'line', data: this.scalingpoints.map(p => [moment(p.timestamp).valueOf(), p.span_value]).slice(0,10)};
      const zero = { name: 'Zero', type: 'line', data: this.scalingpoints.map(p => [moment(p.timestamp).valueOf(), p.zero_point]).slice(0,10)};
      const gas = { name: 'Gas', type: 'line', data: this.scalingpoints.map(p => [moment(p.timestamp).valueOf(), p.gas_concentration]).slice(0,10)};      
      return [span, zero, gas];
    }
  },
  methods: {
    selectRowOnly(r, c, r2, c2) {
      if (this.manualSelection) {
        this.manualSelection = false;
        return;
      }
      const hot = this.$refs.hot.hotInstance;
      hot.deselectCell();
      this.manualSelection = true;
      hot.selectCells([[r, 0, r, hot.countCols() - 1]], false, false);
    },
    async loadInitialData() {
      this.networks = await ScalingService.networks();      
    },
    async showScalingpoints (oc_id) {
      this.scalingpoints = await ScalingService.scalingpoints(oc_id);
      this.showGrid = true;
    },
    async onShowScalingpoints(selection) {
      this.selectedOCId = selection.oc_id;
      await Notify.loadData(null,this.showScalingpoints, selection.oc_id);     
    },
    onEditScalingPoint (t, o) {
      if(o.length > 0) {
        const clickedRow = o[0].start.row;
        const hot = this.$refs.hot.hotInstance;
        const physicalIndex = hot.toPhysicalRow(clickedRow);
        let row = hot.getSourceDataAtRow(physicalIndex);
        this.selectedScalingPoint = row;
        this.edit = true;
      }
    },
    onAddScalingPoint (t, o) {              
        this.add = true;
    },
    onDeleteScalingPoint (t, o) {
      if(o.length > 0) {
        const clickedRow = o[0].start.row;
        const hot = this.$refs.hot.hotInstance;
        const physicalIndex = hot.toPhysicalRow(clickedRow);
        let row = hot.getSourceDataAtRow(physicalIndex);

        Notify.prompt(async response => {
          if (response) {
            await Notify.loadData(
              "Please wait while deleting scaling point",
              async () => {
                const rowsAffected = await ScalingService.delete(row.id);
                const activeEditor = hot.getActiveEditor();
                hot.alter("remove_row", clickedRow, 1);
                Notify.success("Scaling point deleted!");
              }
            );
          }
        }, "This will delete the scaling point. <br/><br/>Do you want to continue?");
      }
    },
    async updateScalingPoint(o) {            
      const res = await ScalingService.update(o);
      o.createdby = res.createdby;
      const current = this.scalingpoints.find(n => n.id == o.id);
      for (var prop in current) {
        if (Object.prototype.hasOwnProperty.call(current, prop)) {
          if (current[prop] != "id" && o[prop]) {
            current[prop] = o[prop];
          }
        }
      }
      Notify.success("Scaling point updated!");
    },
    async insertScalingPoint(o) {
      const res = await ScalingService.insert(o);
      this.scalingpoints = await ScalingService.scalingpoints(o.oc_id);
      Notify.success("Scaling point added!");
    },
    onSaveScalingPoint (o) {   
      if(o.id) {        
        Notify.loadData("Updating scaling point", this.updateScalingPoint,o);
      }
      else {
        o.oc_id = this.selectedOCId;
        Notify.loadData("Inserting scaling point", this.insertScalingPoint,o);
      }
      
      
    },
    onClose () {
      this.add = false;
      this.edit = false;
      this.selectedScalingPoint = {};
    }
  }
};
</script>
<style lang="postcss">
@import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.2/css/all.min.css";
</style>